import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';
import FileModal from 'modules/file/components/FileModal';

export class FileImageRemoveModal extends PureComponent {
  render() {
    return (
      <FileModal
        {...this.props}
        title="player_section.remove_modal.title"
        confirmButtonLabel="general.delete_file_confirm"
      >
        <p>
          <I18n label="player_section.remove_modal.description" />
        </p>
      </FileModal>
    );
  }
}

export class FileImageReplaceModal extends PureComponent {
  render() {
    return (
      <FileModal {...this.props} title="image_section.replace_modal.title">
        <p>
          <I18n label="image_section.replace_modal.description" />
        </p>
      </FileModal>
    );
  }
}
